import { DNode } from '@dojo/framework/core/interfaces';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v } from '@dojo/framework/core/vdom';

import css from '../css/index.m.css';

export interface ContentContainerProperties {
	xqa?: string;
	key?: string;
	id?: string;
	additionalClasses?: string[];
	tabIndex?: number;
}

const factory = create({
	theme
}).properties<ContentContainerProperties>();

export const ContentContainer = factory(({ id: widgetId, properties, children, middleware: { theme } }): DNode => {
	const { container } = theme.classes(css);
	const {
		xqa = 'mc-content-container',
		id,
		key = `content-containerid-${id || widgetId}`,
		additionalClasses = [],
		tabIndex = 0
	} = properties();

	return v(
		'div',
		{ xqa, key, id, widgetId, tabIndex, classes: [theme.variant(), container, ...additionalClasses] },
		children()
	);
});
export default ContentContainer;
